import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";

export const NonCommodityCostComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();

  if (hidden) return null;
  return (
    <div className="sales-doc-field mb-3">
      {/* Optional prompt for certain products */}
      {ctx.nonCommodityPrompt && (
        <div className="sales-doc-prompt mb-3">{ctx.nonCommodityPrompt}</div>
      )}

      {/* Pre-filled / free entry non commodity cost text */}
      <div className="sales-doc-field mb-3">
        <label htmlFor={`meter-${meter.id.toString()}-non-commodity-cost`}>
          Non-commodity Cost
        </label>
        <textarea
          className="auto-height-textarea form-control"
          id={`meter-${meter.id.toString()}-non-commodity-cost`}
          rows={6}
          value={ctx.nonCommodityCost}
          onChange={(e) => {
            ctx.setNonCommodityCost(e.target.value);
          }}
        />
      </div>
    </div>
  );
};
